import React from 'react';
import { string } from 'prop-types';
import './Page.scss';

const Page = ({ children, title }) => (
  <div className="ErrorPage">
    <div className="ErrorPage-container">
      <h1 className="ErrorPage-title" data-qa-id="ErrorPage-title">
        {title}
      </h1>
      <div className="ErrorPage-content" data-qa-id="ErrorPage-content">
        {children}
      </div>
    </div>
  </div>
);

Page.propTypes = {
  title: string,
};

Page.defaultProps = {
  title: "We're sorry… this page does not exist",
};

export default Page;

